// Cliente Supabase del lado browser.
//
// Usa SOLO ANON_KEY. RLS protege los datos: aunque la key es pública, las
// queries que un usuario no autenticado hace devuelven 0 rows (las policies
// requieren `app.current_tenant_id` seteado, lo cual solo pasa via el
// middleware del backend con JWT verificado).
//
// La sesión persiste en localStorage con key 'jidokap-auth' (distinta del
// default 'sb-...' para evitar colisión si el stack se comparte).

import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  throw new Error(
    '[supabase] VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY son requeridas. ' +
      'Revisar docker/web/.env y rebuild.',
  );
}

export const supabase: SupabaseClient = createClient(url, anonKey, {
  auth: {
    persistSession: true,
    storageKey: 'jidokap-auth',
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export const API_URL: string = import.meta.env.VITE_API_URL ?? 'https://api.jidokap.com';
